module.exports = "<div class=\"secure-large-button {{buttonColor}}\">{{buttonText}}</div>\n"